<template>
  <page-component style="position: relative">
    <template #content>
      <v-btn
        v-if="isAdmin || isCustomerService || isAgent"
        color="#451646"
        dark
        fab
        extended
        small
        fixed
        bottom
        left
        class="rt-fab-add-task"
        aria-label="اضافه تذكرة"
        style="width: 122px; border-radius: 20px;"
        @click="dialog = true"
      >
        <v-icon class="rt-fab-add-task__icon">mdi-plus</v-icon>
        اضافه تذكرة
      </v-btn>

      <!-- شريط التبويبات + الأعداد (التصميم الجديد) -->
      <div class="rt-tabs mt-2" role="tablist">
        <button
          type="button"
          class="rt-tab"
          :class="{ 'rt-tab--active': activeTab === 'received' }"
          role="tab"
          :aria-selected="activeTab === 'received'"
          @click="setActiveTab('received')"
        >
          <span class="rt-tab__label">التذاكر المستلمة</span>
          <span class="rt-tab__count">{{ recieved_counter }}</span>
        </button>
        <button
          type="button"
          class="rt-tab"
          :class="{ 'rt-tab--active': activeTab === 'sent' }"
          role="tab"
          :aria-selected="activeTab === 'sent'"
          @click="setActiveTab('sent')"
        >
          <span class="rt-tab__label">التذاكر المرسلة</span>
          <span class="rt-tab__count">{{ sent_counter }}</span>
        </button>
        <button
          type="button"
          class="rt-tab"
          :class="{ 'rt-tab--active': activeTab === 'completed' }"
          role="tab"
          :aria-selected="activeTab === 'completed'"
          @click="setActiveTab('completed')"
        >
          <span class="rt-tab__label">التذاكر المكتملة</span>
          <span class="rt-tab__count">{{ completed_counter }}</span>
        </button>
      </div>

      <v-row class="rt-main mt-4">
        <!-- في RTL: العمود الأول يظهر يميناً = قائمة التذاكر -->
        <v-col cols="12" lg="3">
          <div class="rt-list-panel">
            <template v-if="ticketsForActiveTab.length">
              <button
                v-for="ticket in ticketsForActiveTab"
                :key="ticket.id"
                type="button"
                class="rt-ticket-card"
                :class="{ 'rt-ticket-card--active': selectedTicket && selectedTicket.id === ticket.id }"
                @click="selectTicket(ticket)"
              >
                <div class="rt-ticket-card__body">
                  <div class="rt-ticket-card__title">
                    تذكرة رقم #{{ ticket.id }}
                  </div>
                  <div class="rt-ticket-card__line">
                    <strong>من:</strong>
                    {{ ticket.user && ticket.user.name }}
                  </div>
                  <div class="rt-ticket-card__line">
                    <strong>إلى:</strong>
                    {{ ticket.receive && ticket.receive.name }}
                  </div>
                  <div class="rt-ticket-card__subject" v-if="ticket.status">
                    {{ ticket.status }}
                  </div>
                  <div class="rt-ticket-card__meta">
                    <v-icon small class="rt-ticket-card__meta-icon">mdi-calendar-clock</v-icon>
                    {{ formatTicketDate(ticket.created_at) }}
                  </div>
                </div>
                <aside class="rt-ticket-card__aside">
                  <v-chip x-small class="rt-ticket-card__chip" color="#451646" outlined>
                    {{ ticket.status || "—" }}
                  </v-chip>
                  <v-btn
                    icon
                    small
                    color="#451646"
                    class="mt-2"
                    title="فتح في صفحة كاملة"
                    @click.stop="to_ticket_details(ticket.id)"
                  >
                    <v-icon small>mdi-open-in-new</v-icon>
                  </v-btn>
                </aside>
              </button>
            </template>
            <div v-else class="rt-empty">
              <div class="rt-empty__box">
                <v-icon color="#0e807f" size="48">mdi-ticket-percent-outline</v-icon>
                <p class="rt-empty__title">لا توجد تذاكر</p>
                <p class="rt-empty__hint">لم يتم العثور على تذاكر في هذا القسم</p>
              </div>
            </div>
          </div>
        </v-col>

        <v-col cols="12" lg="9">
          <v-sheet class="rt-detail" elevation="0">
            <v-overlay absolute :value="detailLoading" v-if="0" opacity="0.12" color="#451646" />
            <template v-if="selectedTicket">
              <div class="rt-detail__header">
                <div>
                  <div class="rt-detail__subject">
                    {{ ticketHeaderTitle }}
                  </div>
                  <div class="rt-detail__sub">
                    من: {{ ticketHeaderFrom }} · إلى: {{ ticketHeaderTo }}
                  </div>
                </div>
                <div class="rt-detail__header-end">
                  <div
                    class="rt-detail__msg-count"
                    :title="detailLoading ? 'جاري التحميل' : `عدد الرسائل: ${ticketMessagesCount}`"
                  >
                    <v-icon small class="rt-detail__msg-count-icon">mdi-message-text-outline</v-icon>
                    <template v-if="detailLoading">
                      <span class="rt-detail__msg-count-loading">…</span>
                    </template>
                    <template v-else>
                      <strong class="rt-detail__msg-count-num">{{ ticketMessagesCount }}</strong>
                      <span class="rt-detail__msg-count-label">رسائل</span>
                    </template>
                  </div>
                  <v-btn icon small @click="to_ticket_details(selectedTicket.id)" title="فتح في صفحة كاملة">
                    <v-icon>mdi-open-in-new</v-icon>
                  </v-btn>
                </div>
              </div>
              <!-- <v-divider /> -->
              <div class="rt-detail__thread">
                <div
                  v-for="item in mergedTaskContents"
                  :key="item.uid"
                  class="rt-msg"
                  :class="{ 'rt-msg--receiver': item.role === 'receiver' }"
                >
                  <div class="rt-msg__bubble">
                    <div class="rt-msg__text">{{ item.content }}</div>
                    <div class="rt-msg__meta">
                      <span>{{ item.authorName }}</span>
                      <span>{{ item.date_of_content }}</span>
                    </div>
                  </div>
                </div>
                <div v-if="!mergedTaskContents.length && !detailLoading" class="rt-detail__thread-empty">
                  لا يوجد ردود بعد؛ ابدأ بكتابة رسالة بالأسفل.
                </div>
              </div>
              <div v-if="can_reply_on_task" class="rt-detail__composer">
                <div class="rt-detail__composer-row">
                  <v-textarea
                    v-model="task_content"
                    outlined
                    dense
                    hide-details
                    rows="2"
                    auto-grow
                    placeholder="أدخل رسالتك هنا..."
                    class="rt-detail__textarea rt-detail__textarea--grow"
                  />
                  <div class="rt-detail__composer-actions">
                    <v-btn
                      depressed
                      rounded
                      :ripple="false"
                      :loading="reply_loading"
                      :disabled="!task_content || !task_content.trim() || detailLoading"
                      class="rt-detail__reply-btn"
                      @click="reply_ticket_content"
                    >
                      نشر
                    </v-btn>
                  </div>
                </div>
              </div>
              <div v-else-if="!detailLoading && replyBlockedHint" class="rt-detail__composer-hint">
                {{ replyBlockedHint }}
              </div>
              <div class="rt-detail__footer">
                <v-btn
                  v-if="can_send_transfer_to_admin"
                  color="#0e807f"
                  depressed
                  block
                  large
                  class="mb-2"
                  :loading="transfer_to_admin_loading"
                  :disabled="transfer_to_admin_loading || cancel_loading"
                  @click="transfer_to_admin_confirm = true"
                >
                  ارسال طلب تحويل للادمن
                </v-btn>
                <v-btn
                  color="#451646"
                  outlined
                  depressed
                  block
                  large
                  :loading="cancel_loading"
                  :disabled="transfer_to_admin_loading"
                  @click="close_task"
                >
                  إلغاء التذكرة
                </v-btn>
              </div>
            </template>
            <div v-else class="rt-detail-placeholder">
              <v-icon color="#451646" size="56" class="mb-3">mdi-ticket-outline</v-icon>
              <p class="rt-detail-placeholder__title">اختر تذكرة</p>
              <p class="rt-detail-placeholder__hint">
                اختر إحدى التذاكر من القائمة لعرض المحادثة والرد عليها من هنا.
              </p>
            </div>
          </v-sheet>
        </v-col>
      </v-row>

      <v-dialog
        v-model="transfer_to_admin_confirm"
        max-width="480"
        persistent
      >
        <v-card>
          <v-card-title class="text-h6" style="color: #451646">
            تأكيد ارسال التحويل
          </v-card-title>
          <v-card-text>
            هل أنت متأكد من ارسال طلب تحويل للادمن؟
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              text
              :disabled="transfer_to_admin_loading"
              @click="transfer_to_admin_confirm = false"
            >
              إلغاء
            </v-btn>
            <v-btn
              color="#0e807f"
              dark
              depressed
              :loading="transfer_to_admin_loading"
              @click="send_transfer_to_admin"
            >
              تأكيد
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="dialog"
        max-width="560"
        scrollable
        content-class="rt-add-task-dialog-wrap"
      >
        <v-card class="rt-add-task-dialog-card">
          <v-card-title class="rt-add-task-dialog__title">
            محتوى التذكرة
          </v-card-title>
          <v-divider />
          <v-card-text class="rt-add-task-dialog__body">
            <v-textarea
              v-model="content"
              outlined
              dense
              hide-details
              rows="5"
              auto-grow
              placeholder="اكتب محتوى التذكرة..."
              class="rt-add-task-dialog__field mb-2"
            />
            <v-autocomplete
              v-model="recieve"
              :items="items"
              item-text="name"
              item-value="id"
              label="مستلم التذكرة"
              outlined
              dense
              hide-details
              clearable
              class="rt-add-task-dialog__field"
              @change="reChangeContent"
            >
              <template v-slot:item="{ item, attrs, on }">
                <v-list-item v-bind="attrs" v-on="on">
                  <v-list-item-title
                    :id="attrs['aria-labelledby']"
                    v-text="item.name"
                  />
                </v-list-item>
              </template>
            </v-autocomplete>
          </v-card-text>
          <v-divider />
          <v-card-actions class="rt-add-task-dialog__actions">
            <v-spacer />
            <v-btn text @click="dialog = false">إلغاء</v-btn>
            <v-btn color="#451646" dark depressed @click="saveTaskForRequest">
              إضافة
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </page-component>
</template>

<script>
import Axios from "axios";
import { axiosInstance } from "@/axios/config";
import tasksApi from "@/services/tasks";

export default {
  props: ["agent"],
  data() {
    return {
      agent_data: {},
      recieved_tickets: [],
      completed_tickets: [],
      sent_tickets: [],
      sent_counter: 0,
      recieved_counter: 0,
      completed_counter: 0,
      dialog: false,
      recieve: null,
      content: "",
      items: [],
      greeting: null,
      activeTab: "received",
      selectedTicket: null,
      ticket_details: {},
      detailLoading: false,
      task_content: "",
      reply_loading: false,
      cancel_loading: false,
      transfer_to_admin_loading: false,
      transfer_to_admin_confirm: false,
      conversationFetchSeq: 0,
      current_user: (() => {
        try {
          const raw = document.cookie
            .split(";")
            .map((coki) => coki.split("="))
            .reduce(
              (acc, [key, val]) => ({
                ...acc,
                [key.trim()]: decodeURIComponent(val),
              }),
              {}
            ).wsataJwt;
          return raw ? JSON.parse(raw) : {};
        } catch {
          return {};
        }
      })(),
    };
  },
  computed: {
    ticketRequestFilterId() {
      const routeId = this.$route.params.id;
      if (routeId !== undefined && routeId !== null && routeId !== "") {
        return routeId;
      }
      return this.agent && this.agent.id != null ? this.agent.id : null;
    },
    isAdmin() {
      const v = localStorage.getItem("isAdmin");
      return v === "true" || v === "1" || v === true;
    },
    isCustomerService() {
      const role = localStorage.getItem("role");
      const isCustomerServiceFlag = localStorage.getItem("is_customer_service");
      return role === "0" && isCustomerServiceFlag === "1";
    },
    isAgent() {
      const role = localStorage.getItem("role");
      const isAgentFlag = localStorage.getItem("is_customer_service");
      return role === "0" && isAgentFlag === "0";
    },
    ticketsForActiveTab() {
      if (this.activeTab === "received") return this.recieved_tickets;
      if (this.activeTab === "sent") return this.sent_tickets;
      return this.completed_tickets;
    },
    mergedTaskContents() {
      return this.buildConversationMessages(this.ticket_details);
    },
    ticketMessagesCount() {
      return this.mergedTaskContents.length;
    },
    ticketHeaderTitle() {
      if (this.selectedTicket && this.selectedTicket.status) {
        return this.selectedTicket.status;
      }
      if (this.ticket_details && this.ticket_details.status) {
        return this.ticket_details.status;
      }
      return this.selectedTicket ? `تذكرة #${this.selectedTicket.id}` : "";
    },
    ticketHeaderFrom() {
      return (this.selectedTicket && this.selectedTicket.user && this.selectedTicket.user.name) || "—";
    },
    ticketHeaderTo() {
      return (this.selectedTicket && this.selectedTicket.receive && this.selectedTicket.receive.name) || "—";
    },
    lastTaskContentRow() {
      const rows = this.ticket_details && this.ticket_details.taskContentMany;
      if (!Array.isArray(rows) || !rows.length) return null;
      return rows[rows.length - 1];
    },
    can_reply_on_task() {
      const td = this.ticket_details || {};
      const last = this.lastTaskContentRow;
      const agentId = parseInt(this.current_user && this.current_user.agent_id, 10);
      if (!agentId || !last) return false;
      const closed = [3, 4, 5].includes(Number(td.status2));
      if (closed) return false;

      const isReceiver = Number(td.recive_id) === agentId;
      const isSender = td.user && Number(td.user.id) === agentId;

      if (isReceiver) {
        return !last.user_note;
      }
      if (isSender) {
        return !!(last.user_note && last.content);
      }
      return false;
    },
    replyBlockedHint() {
      const td = this.ticket_details || {};
      const last = this.lastTaskContentRow;
      if (!last || !this.selectedTicket) return "";
      const closed = [3, 4, 5].includes(Number(td.status2));
      if (closed) return "لا يمكن الرد؛ التذكرة مكتملة أو مغلقة.";

      const agentId = parseInt(this.current_user && this.current_user.agent_id, 10);
      if (!agentId) return "";

      if (Number(td.recive_id) === agentId && last.user_note) {
        return "تم إرسال ردك. انتظر رد المرسل قبل إرسال رسالة جديدة.";
      }
      if (td.user && Number(td.user.id) === agentId && !last.user_note) {
        return "في انتظار رد المستلم قبل إرسال رسالة جديدة.";
      }
      return "لا يمكنك إرسال رسالة في هذه المرحلة.";
    },
    can_send_transfer_to_admin() {
      const td = this.ticket_details || {};
      const listTicket = this.selectedTicket || {};
      const agentId = parseInt(this.current_user && this.current_user.agent_id, 10);
      if (!agentId || !this.selectedTicket) return false;

      const isAutomatic =
        td.is_sent_automatically === true ||
        td.is_sent_automatically === 1 ||
        td.is_sent_automatically === "1" ||
        listTicket.is_sent_automatically === true ||
        listTicket.is_sent_automatically === 1 ||
        listTicket.is_sent_automatically === "1";
      if (!isAutomatic) return false;

      const receiveId =
        td.recive_id != null ? td.recive_id : listTicket.recive_id;
      if (Number(receiveId) !== agentId) return false;

      const status2 =
        td.status2 != null && td.status2 !== ""
          ? Number(td.status2)
          : listTicket.status2 != null && listTicket.status2 !== ""
            ? Number(listTicket.status2)
            : null;

      if (status2 != null && !Number.isNaN(status2)) {
        return [0, 1, 2].includes(status2);
      }

      const statusText = String(td.status || listTicket.status || "").trim();
      const closedArabic = ["مكتملة", "مكتمله", "غير مكتملة", "غير مكتمله", "ملغاة", "ملغاه", "مغلقة", "مغلقه"];
      return statusText && !closedArabic.some((s) => statusText.includes(s));
    },
  },
  watch: {
    agent_data: {
      handler(val) {
        if (!val || !val.customer) return;
        val.source = parseInt(val.source, 10);
        val.customer.work = parseInt(val.customer.work, 10);
        this.setBreadCrumbs(["الرئيسية", "الطلبات", val.customer.name]);
      },
    },
    activeTab() {
      this.$nextTick(() => this.syncSelectionAfterLoad());
    },
  },
  created() {
    this.agent_data = this.agent;
    this.get_request_tickets();
    this.setBreadCrumbs(["الرئيسية", "الطلبات", this.agent.customer.name]);
    this.getRecievedUsers();
  },
  methods: {
    formatTicketDate(createdAt) {
      if (!createdAt || typeof createdAt !== "string") return "—";
      return createdAt.split(".")[0].split("T").join(" | ");
    },
    buildConversationMessages(ticketDetails) {
      const td = ticketDetails || {};
      const rows = Array.isArray(td.taskContentMany)
        ? td.taskContentMany
        : Array.isArray(td.task_content_many)
          ? td.task_content_many
          : [];
      const senderName = (td.user && td.user.name) || "—";
      const receiverName = (td.receive && td.receive.name) || "—";
      const messages = [];

      rows.forEach((item, index) => {
        const rowKey = item.id != null ? item.id : `row-${index}`;
        if (item.content) {
          messages.push({
            uid: `${rowKey}-sender`,
            content: item.content,
            date_of_content: item.date_of_content,
            authorName: senderName,
            role: "sender",
          });
        }
        if (item.user_note) {
          messages.push({
            uid: `${rowKey}-receiver`,
            content: item.user_note,
            date_of_content: item.date_of_note,
            authorName: receiverName,
            role: "receiver",
          });
        }
      });

      return messages;
    },
    setActiveTab(tab) {
      this.activeTab = tab;
    },
    get_request_tickets(options = {}) {
      const reqId = this.ticketRequestFilterId;
      if (reqId === null || reqId === undefined || reqId === "") {
        return Promise.resolve();
      }
      const headers = this.request_headers();
      const base = this.$store.state.url;
      return Promise.all([
        Axios.get(`${base}/agent/ReceivedTasks?req_id=${reqId}`, { headers }),
        Axios.get(`${base}/agent/SentTasks?req_id=${reqId}`, { headers }),
        Axios.get(`${base}/agent/CompletedTasks?req_id=${reqId}`, { headers }),
      ])
        .then(([r1, r2, r3]) => {
          this.recieved_tickets = (r1.data.payload || []).filter(
            (el) => String(el.req_id) === String(reqId)
          );
          this.recieved_counter = this.recieved_tickets.length;
          this.sent_tickets = (r2.data.payload || []).filter(
            (el) => String(el.req_id) === String(reqId)
          );
          this.sent_counter = this.sent_tickets.length;
          this.completed_tickets = (r3.data.payload || []).filter(
            (el) => String(el.req_id) === String(reqId)
          );
          this.completed_counter = this.completed_tickets.length;
          if (options.syncSelection !== false) {
            this.syncSelectionAfterLoad();
          } else {
            this.refreshSelectedTicketFromLists();
          }
        })
        .catch((err) => {
          this.showPopup("error", err.response?.data?.message || err.message);
        });
    },
    refreshSelectedTicketFromLists() {
      if (!this.selectedTicket) return;
      const all = [
        ...this.recieved_tickets,
        ...this.sent_tickets,
        ...this.completed_tickets,
      ];
      const updated = all.find((t) => t.id === this.selectedTicket.id);
      if (updated) this.selectedTicket = updated;
    },
    syncSelectionAfterLoad() {
      const list = this.ticketsForActiveTab;
      if (!list.length) {
        this.selectedTicket = null;
        this.ticket_details = {};
        this.task_content = "";
        return;
      }
      if (this.selectedTicket && list.some((t) => t.id === this.selectedTicket.id)) {
        this.fetchConversation(this.selectedTicket.id);
        return;
      }
      this.selectTicket(list[0]);
    },
    selectTicket(ticket) {
      this.selectedTicket = ticket;
      this.task_content = "";
      this.ticket_details = {};
      this.fetchConversation(ticket.id);
    },
    fetchConversation(ticketId) {
      const seq = ++this.conversationFetchSeq;
      this.detailLoading = true;
      return axiosInstance
        .get(`/agent/Task/Conversation/${ticketId}`)
        .then((response) => {
          if (seq !== this.conversationFetchSeq) return;
          if (!this.selectedTicket || this.selectedTicket.id !== ticketId) return;
          this.ticket_details = response.data.payload || {};
          this.$root.$emit("refreshTopBarFunctionality");
        })
        .catch((err) => {
          if (seq !== this.conversationFetchSeq) return;
          this.showPopup("error", err.response?.data?.message || err.message);
          this.ticket_details = {};
        })
        .finally(() => {
          if (seq === this.conversationFetchSeq) {
            this.detailLoading = false;
          }
        });
    },
    reply_ticket_content() {
      if (
        !this.selectedTicket ||
        !this.task_content ||
        !this.task_content.trim() ||
        !this.can_reply_on_task
      ) {
        return;
      }
      this.reply_loading = true;
      const ticketId = this.selectedTicket.id;
      const data = {
        task_content_id: ticketId,
        task_content: this.task_content.trim(),
      };
      axiosInstance
        .post("/agent/Task/Conversation/AddContent", data)
        .then(() => {
          this.showPopup("success", "تم إرسال الرد بنجاح");
          this.task_content = "";
          this.$root.$emit("refreshTopBarFunctionality");
          return this.fetchConversation(ticketId);
        })
        .then(() => this.get_request_tickets({ syncSelection: false }))
        .catch((err) => {
          this.showPopup("error", err.response?.data?.message || err.message);
        })
        .finally(() => {
          this.reply_loading = false;
        });
    },
    close_task() {
      if (!this.selectedTicket) return;
      this.cancel_loading = true;
      Axios.put(`${this.$store.state.url}/agent/CancelTask/${this.selectedTicket.id}`, null, {
        headers: this.request_headers(),
      })
        .then(() => {
          this.showPopup("success", "تم إلغاء التذكرة بنجاح");
          this.get_request_tickets();
        })
        .catch((err) => {
          this.showPopup("error", err.response?.data?.message || err.message);
        })
        .finally(() => {
          this.cancel_loading = false;
        });
    },
    send_transfer_to_admin() {
      if (!this.selectedTicket || !this.can_send_transfer_to_admin) return;
      const ticketId = this.selectedTicket.id;
      this.transfer_to_admin_loading = true;
      tasksApi
        .sendTransferToAdmin(ticketId)
        .then((res) => {
          const message =
            (res.data && res.data.message) ||
            "تم ارسال طلب التحويل للادمن بنجاح";
          this.showPopup("success", message);
          this.transfer_to_admin_confirm = false;
          if (this.ticket_details && this.ticket_details.id === ticketId) {
            this.ticket_details = {
              ...this.ticket_details,
              status2: 3,
              status: "مكتملة",
            };
          }
          if (this.selectedTicket && this.selectedTicket.id === ticketId) {
            this.selectedTicket = {
              ...this.selectedTicket,
              status2: 3,
              status: "مكتملة",
            };
          }
          this.$root.$emit("refreshTopBarFunctionality");
          return this.get_request_tickets();
        })
        .catch((err) => {
          this.showPopup("error", err.response?.data?.message || err.message);
        })
        .finally(() => {
          this.transfer_to_admin_loading = false;
        });
    },
    to_ticket_details(id) {
      if (this.isAdmin) {
        this.$router.push({ name: "admin_tickets_details", params: { ticeket: id } });
      } else {
        this.$router.push({ name: "ticket_details", params: { ticket: id } });
      }
    },
    reChangeContent(selectedId) {
      if (!Array.isArray(this.items)) return;
      const selectedUser = this.items.find((item) => item.id === selectedId);
      if (selectedUser) {
        const prefix =
          this.greeting != null && this.greeting !== "" ? `${this.greeting} - ` : "";
        this.content = prefix + selectedUser.name;
      }
    },
    getRecievedUsers() {
      axiosInstance
        .get(`employee/admin/TaskReceivers/${this.agent.id}`)
        .then((res) => {
          const payload = res.data.payload || {};
          this.items = Array.isArray(payload.allUsers) ? payload.allUsers : [];
          this.greeting = payload.greeting ?? null;
          this.items.forEach((item) => {
            item.color = "red";
            item.text = item.name;
          });
        })
        .catch((err) => {
          this.showPopup("error", err.response?.data?.message || err.message);
        });
    },
    saveTaskForRequest() {
      let body = new FormData();
      body.append("request_id", this.agent.id);
      body.append("task_content", this.content);
      body.append("received_id", this.recieve);
      axiosInstance
        .post("employee/admin/AddNewTask", body)
        .then((res) => {
          this.showPopup("success", res.data.message);
          this.get_request_tickets();
          this.dialog = false;
        })
        .catch((err) => {
          this.showPopup("error", err.response?.data?.message || err.message);
        });
    },
  },
};
</script>

<style scoped>
.rt-head__title {
  font-family: Cairo, sans-serif;
  font-size: 1.35rem;
  font-weight: 700;
  color: #451646;
  margin: 0;
}

/* Fixed bottom-left FAB — add task */
.rt-fab-add-task.v-btn--fab.v-btn--extended {
  left: 20px !important;
  right: auto !important;
  bottom: calc(24px + env(safe-area-inset-bottom, 0px)) !important;
  top: auto !important;
  z-index: 6 !important;
  border-radius: 999px !important;
  font-weight: 700 !important;
  letter-spacing: 0.02em;
  text-transform: none !important;
  box-shadow: 0 6px 20px rgba(69, 22, 70, 0.42) !important;
}

.rt-fab-add-task >>> .rt-fab-add-task__icon {
  margin-inline-end: 8px;
}

.rt-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  background: #ede7f6;
  border-radius: 12px;
  padding: 8px;
}
.rt-tab {
  flex: 1 1 140px;
  border: none;
  border-radius: 10px;
  padding: 12px 14px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.65);
  color: #451646;
  font-family: Cairo, sans-serif;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  transition: background 0.15s ease, color 0.15s ease;
}
.rt-tab--active {
  background: #451646;
  color: #fff;
}
.rt-tab__count {
  font-weight: 800;
  min-width: 1.5em;
  text-align: center;
}

.rt-list-panel {
  min-height: 52vh;
  max-height: 72vh;
  overflow: auto;
  padding-bottom: 8px;
}

.rt-ticket-card {
  width: 100%;
  display: flex;
  flex-direction: row;
  text-align: right;
  border: 2px dashed #c5bdd6;
  border-radius: 14px;
  background: #fff;
  margin-bottom: 14px;
  padding: 0;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.rt-ticket-card:hover {
  border-color: #451646;
  box-shadow: 0 4px 14px rgba(69, 22, 70, 0.12);
}
.rt-ticket-card--active {
  border-color: #451646;
  border-style: dashed;
  box-shadow: 0 4px 18px rgba(69, 22, 70, 0.18);
}
.rt-ticket-card__body {
  flex: 1 1 65%;
  padding: 14px 16px;
}
.rt-ticket-card__aside {
  flex: 0 0 35%;
  max-width: 140px;
  background: #e8e0f4;
  padding: 12px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
}
.rt-ticket-card__title {
  font-weight: 800;
  color: #451646;
  margin-bottom: 8px;
  font-size: 0.95rem;
}
.rt-ticket-card__line {
  font-size: 0.88rem;
  color: #333;
  margin-bottom: 4px;
}
.rt-ticket-card__subject {
  font-weight: 700;
  color: #2c2c2c;
  margin-top: 8px;
  font-size: 0.92rem;
}
.rt-ticket-card__meta {
  margin-top: 10px;
  font-size: 0.8rem;
  color: #666;
  display: flex;
  align-items: center;
  gap: 6px;
}
.rt-ticket-card__meta-icon {
  color: #451646 !important;
}

.rt-empty {
  min-height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rt-empty__box {
  border: 2px dashed #c5bdd6;
  border-radius: 14px;
  padding: 32px 24px;
  text-align: center;
  max-width: 360px;
  background: #fafafa;
}
.rt-empty__title {
  font-weight: 800;
  color: #451646;
  margin: 12px 0 4px;
  font-size: 1.1rem;
}
.rt-empty__hint {
  color: #888;
  font-size: 0.9rem;
  margin: 0;
}

.rt-detail {
  position: relative;
  border-radius: 14px;
  border: 1px solid #e4e0ec;
  min-height: 52vh;
  max-height: 72vh;
  display: flex;
  flex-direction: column;
  background: #fff;
}
.rt-detail__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 18px 8px;
}
.rt-detail__header-end {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 4px;
}
.rt-detail__msg-count {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8rem;
  color: #555;
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(69, 22, 70, 0.06);
  border: 1px solid rgba(69, 22, 70, 0.18);
  white-space: nowrap;
}
.rt-detail__msg-count-num {
  font-weight: 800;
  color: #451646;
  font-variant-numeric: tabular-nums;
}
.rt-detail__msg-count-label {
  font-weight: 600;
  color: #5c3569;
  margin-inline-start: 2px;
}
.rt-detail__msg-count-loading {
  font-weight: 700;
  letter-spacing: 2px;
  color: #451646;
}
.rt-detail__msg-count-icon {
  color: #451646 !important;
  opacity: 0.9;
}
.rt-detail__subject {
  font-weight: 800;
  color: #451646;
  font-size: 1.05rem;
}
.rt-detail__sub {
  font-size: 0.85rem;
  color: #666;
  margin-top: 4px;
}
.rt-detail__thread {
  flex: 1 1 auto;
  overflow: auto;
  padding: 12px 16px;
  background: #fafafa;
}
.rt-detail__thread-empty {
  text-align: center;
  color: #888;
  padding: 24px 8px;
  font-size: 0.9rem;
}
.rt-msg {
  margin-bottom: 12px;
}
.rt-msg__bubble {
  background: #fff;
  border-radius: 12px;
  padding: 12px 14px;
  border: 1px solid #ece8f2;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.rt-msg--receiver .rt-msg__bubble {
  background: #f3e8f8;
  border-color: #d9c4e8;
}
.rt-msg--receiver .rt-msg__meta span:first-child {
  color: #5e2766;
  font-weight: 700;
}
.rt-msg__text {
  font-size: 0.95rem;
  color: #222;
  line-height: 1.5;
}
.rt-msg__meta {
  margin-top: 8px;
  font-size: 0.78rem;
  color: #888;
  display: flex;
  justify-content: space-between;
  gap: 8px;
}
.rt-detail__composer {
  padding: 0px 16px 1px;
  border-top: 1px solid #eee;
  background: #fff;
}
.rt-detail__composer-hint {
  padding: 12px 16px 14px;
  border-top: 1px solid #eee;
  background: #faf8fc;
  color: #5c3569;
  font-size: 0.88rem;
  line-height: 1.5;
  text-align: center;
}

.rt-detail__composer-row {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  gap: 10px;
}

.rt-detail__textarea--grow {
  flex: 1 1 auto;
  min-width: 0;
}

.rt-detail__composer-row >>> .rt-detail__textarea--grow.v-text-field {
  margin-top: 0;
  padding-top: 0;
}

.rt-detail__textarea >>> textarea {
  font-size: 0.95rem;
}
.rt-detail__composer-actions {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 auto;
  margin-top: 0;
  padding-bottom: 4px;
}

@media (max-width: 599px) {
  .rt-detail__composer-row {
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
  }
  .rt-detail__composer-actions {
    padding-bottom: 0;
    justify-content: stretch;
  }
  .rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn {
    width: 100%;
  }
}

/* Reply ("نشر") — deep selectors: Vuetify v-btn root + theme utilities can override plain scoped rules */
.rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn:not(.v-btn--disabled):not(.v-btn--loading) {
  min-height: 40px !important;
  min-width: 104px !important;
  padding: 0 22px !important;
  border-radius: 10px !important;
  font-weight: 700 !important;
  font-size: 0.9375rem !important;
  letter-spacing: 0.02em;
  text-transform: none !important;
  border: none !important;
  box-shadow: 0 2px 10px rgba(69, 22, 70, 0.28) !important;
  background-color: #451646 !important;
  background-image: linear-gradient(165deg, #5e2766 0%, #451646 50%, #3a1140 100%) !important;
  color: #ffffff !important;
  transition:
    box-shadow 0.18s ease,
    filter 0.18s ease,
    opacity 0.18s ease;
}

.rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn:not(.v-btn--disabled):not(.v-btn--loading)::before {
  opacity: 0 !important;
  background-color: transparent !important;
}

.rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn:not(.v-btn--disabled):not(.v-btn--loading):hover {
  box-shadow: 0 4px 16px rgba(69, 22, 70, 0.36) !important;
  filter: brightness(1.07);
}

.rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn:not(.v-btn--disabled):not(.v-btn--loading):focus-visible {
  box-shadow:
    0 0 0 3px rgba(69, 22, 70, 0.38),
    0 4px 14px rgba(69, 22, 70, 0.28) !important;
}

.rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn .v-btn__content {
  color: #ffffff !important;
  opacity: 1 !important;
}

.rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn.v-btn--disabled {
  opacity: 1 !important;
  box-shadow: none !important;
  filter: none !important;
  background-color: #d9d0e4 !important;
  background-image: none !important;
  color: rgba(255, 255, 255, 0.92) !important;
}

.rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn.v-btn--disabled .v-btn__content {
  color: rgba(255, 255, 255, 0.95) !important;
}

.rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn.v-btn--loading:not(.v-btn--disabled) {
  background-color: #451646 !important;
  background-image: linear-gradient(165deg, #5e2766 0%, #451646 50%, #3a1140 100%) !important;
  color: rgba(255, 255, 255, 0.96) !important;
}

.rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn .v-progress-circular {
  color: #ffffff !important;
}

.rt-detail__footer {
  padding: 8px 16px 16px;
}
.rt-detail-placeholder {
  min-height: 48vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 24px;
  color: #666;
}
.rt-detail-placeholder__title {
  font-weight: 800;
  color: #451646;
  font-size: 1.1rem;
  margin: 0 0 8px;
}
.rt-detail-placeholder__hint {
  max-width: 320px;
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.5;
}

.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  color: #ced4da !important;
}

/* Add-task dialog */
.rt-add-task-dialog-card {
  border-radius: 12px !important;
  overflow: hidden;
}
.rt-add-task-dialog__title {
  font-family: Cairo, sans-serif;
  font-weight: 700;
  font-size: 1.15rem !important;
  color: #451646;
  padding: 18px 20px 16px !important;
}
.rt-add-task-dialog__body {
  padding: 16px 20px 20px !important;
}
.rt-add-task-dialog__field {
  margin-bottom: 0;
}
.rt-add-task-dialog__actions {
  padding: 12px 16px 16px !important;
  flex-wrap: wrap;
  gap: 8px;
}

/* Dark theme: app uses html.dark / body.dark (Vuex SET_THEME), not Vuetify .theme--dark */
html.dark .rt-head__title {
  color: #f3e5f5;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.35);
}
html.dark .rt-fab-add-task.v-btn--fab.v-btn--extended {
  box-shadow:
    0 8px 26px rgba(0, 0, 0, 0.55),
    0 0 0 1px rgba(255, 255, 255, 0.12) !important;
}
/* Tabs — stronger separation from page background */
html.dark .rt-tabs {
  background: #2a2438;
  border: 1px solid rgba(206, 147, 216, 0.35);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
}
html.dark .rt-tab {
  background: rgba(255, 255, 255, 0.09);
  color: #f5f0fa;
  border: 1px solid transparent;
}
html.dark .rt-tab:hover {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(206, 147, 216, 0.25);
}
html.dark .rt-tab--active {
  background: linear-gradient(160deg, #8e5aaf 0%, #6b4080 100%);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.22);
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.4);
}
html.dark .rt-tab__count {
  opacity: 1;
  font-weight: 900;
}
html.dark .rt-tab--active .rt-tab__count {
  color: rgba(255, 255, 255, 0.95);
}
/* Ticket list column — slight runway so cards pop */
html.dark .rt-list-panel {
  padding: 8px;
  margin: -4px;
  border-radius: 16px;
  background: rgba(8, 6, 14, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.06);
}
html.dark .rt-ticket-card {
  background: linear-gradient(145deg, #353049 0%, #292536 55%, #221f2e 100%) !important;
  border: 2px solid rgba(187, 134, 222, 0.42) !important;
  border-style: solid !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.45);
}
html.dark .rt-ticket-card:hover {
  border-color: rgba(206, 167, 240, 0.75) !important;
  box-shadow: 0 6px 22px rgba(0, 0, 0, 0.55);
}
html.dark .rt-ticket-card--active {
  border-color: #e1bee7 !important;
  border-style: dashed !important;
  box-shadow:
    0 0 0 1px rgba(225, 190, 231, 0.35),
    0 6px 24px rgba(138, 77, 168, 0.35);
}
html.dark .rt-ticket-card__body {
  background: transparent;
}
html.dark .rt-ticket-card__aside {
  background: rgba(74, 45, 92, 0.55) !important;
  border-inline-start: 1px solid rgba(255, 255, 255, 0.14);
}
html.dark .rt-ticket-card__title {
  color: #fce4fc;
  font-size: 1rem;
  letter-spacing: 0.01em;
}
html.dark .rt-ticket-card__line {
  color: #e8dff7;
}
html.dark .rt-ticket-card__line strong {
  color: #fff;
  font-weight: 800;
}
html.dark .rt-ticket-card__subject {
  color: #fff;
  font-weight: 800;
}
html.dark .rt-ticket-card__meta {
  color: #c9bddc;
  font-weight: 500;
}
html.dark .rt-ticket-card__meta-icon {
  color: #eaabf8 !important;
}
html.dark .rt-ticket-card >>> .v-btn--icon .v-icon,
html.dark .rt-ticket-card .v-btn--icon >>> .v-icon {
  color: #f3e5f5 !important;
}
html.dark .rt-ticket-card__chip.v-chip.v-chip--outlined {
  border-width: 2px !important;
  border-color: rgba(234, 171, 248, 0.85) !important;
  color: #fce4fc !important;
  background: rgba(0, 0, 0, 0.2) !important;
}
html.dark .rt-empty__box {
  background: #322d42;
  border-color: rgba(206, 147, 216, 0.45);
  border-style: solid;
}
html.dark .rt-empty__title {
  color: #f3e5f5;
}
html.dark .rt-empty__hint {
  color: #cbbfda;
}
html.dark .rt-empty .v-icon {
  color: #80deea !important;
}
html.dark .rt-detail.v-sheet,
html.dark .rt-detail {
  background-color: #1e1e1e !important;
  border-color: #4a4458;
}
html.dark .rt-detail__subject {
  color: #e1bee7;
}
html.dark .rt-detail__sub {
  color: #b0a3c4;
}
html.dark .rt-detail__msg-count {
  color: #e0dce8;
  background: rgba(206, 147, 216, 0.14);
  border-color: rgba(206, 147, 216, 0.38);
}
html.dark .rt-detail__msg-count-num {
  color: #fce4fc;
}
html.dark .rt-detail__msg-count-label {
  color: #e1bee7;
}
html.dark .rt-detail__msg-count-loading {
  color: #e1bee7;
}
html.dark .rt-detail__msg-count-icon {
  color: #ce93d8 !important;
}
html.dark .rt-detail >>> .v-divider,
html.dark .rt-detail .v-divider {
  border-color: rgba(255, 255, 255, 0.12) !important;
}
html.dark .rt-detail__thread {
  background: #18151f;
}
html.dark .rt-detail__thread-empty {
  color: #9e92b0;
}
html.dark .rt-msg__bubble {
  background: #252030 !important;
  border-color: #3d3848;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.35);
}
html.dark .rt-msg--receiver .rt-msg__bubble {
  background: #3a2848 !important;
  border-color: #6b4080;
}
html.dark .rt-msg--receiver .rt-msg__meta span:first-child {
  color: #e1bee7;
}
html.dark .rt-msg__text {
  color: #eeeef5;
}
html.dark .rt-msg__meta {
  color: #a89bb8;
}
html.dark .rt-detail__composer {
  background: #1e1e1e;
  border-top: 1px solid #3d3848;
}
html.dark .rt-detail__composer-hint {
  background: #252030;
  border-top: 1px solid #3d3848;
  color: #cbbfda;
}
html.dark .rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn:not(.v-btn--disabled):not(.v-btn--loading) {
  background-color: #704883 !important;
  background-image: linear-gradient(165deg, #c093da 0%, #955daf 42%, #5e376f 100%) !important;
  color: #ffffff !important;
  box-shadow:
    0 3px 16px rgba(0, 0, 0, 0.42),
    0 0 0 1px rgba(255, 255, 255, 0.12) !important;
}

html.dark .rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn:not(.v-btn--disabled):not(.v-btn--loading)::before {
  opacity: 0 !important;
  background-color: transparent !important;
}

html.dark .rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn:not(.v-btn--disabled):not(.v-btn--loading):hover {
  box-shadow:
    0 5px 22px rgba(149, 93, 175, 0.42),
    0 0 0 1px rgba(255, 255, 255, 0.16) !important;
  filter: brightness(1.06);
}

html.dark .rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn:not(.v-btn--disabled):not(.v-btn--loading):focus-visible {
  box-shadow:
    0 0 0 3px rgba(206, 147, 216, 0.5),
    0 4px 18px rgba(0, 0, 0, 0.45) !important;
}

html.dark .rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn.v-btn--disabled {
  background-color: rgba(255, 255, 255, 0.09) !important;
  background-image: none !important;
  color: rgba(255, 255, 255, 0.38) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

html.dark .rt-detail__composer-actions >>> .rt-detail__reply-btn.v-btn.v-btn--loading:not(.v-btn--disabled) {
  background-color: #704883 !important;
  background-image: linear-gradient(165deg, #c093da 0%, #955daf 42%, #5e376f 100%) !important;
}
html.dark .rt-detail__textarea >>> textarea {
  caret-color: #ce93d8;
}
html.dark .rt-detail-placeholder {
  color: #b0a3c4;
}
html.dark .rt-detail-placeholder .v-icon {
  color: #b39ddb !important;
}
html.dark .rt-detail-placeholder__title {
  color: #e1bee7;
}
html.dark .rt-detail-placeholder__hint {
  color: #9e92b0;
}
html.dark .rt-add-task-dialog-card.v-card {
  background: #2a2438 !important;
  border: 1px solid rgba(206, 147, 216, 0.35);
}
html.dark .rt-add-task-dialog__title {
  color: #f3e5f5 !important;
}
html.dark .rt-add-task-dialog-card .v-divider {
  border-color: rgba(255, 255, 255, 0.12) !important;
}
html.dark .rt-add-task-dialog-card .v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  color: rgba(255, 255, 255, 0.35) !important;
}
html.dark .rt-add-task-dialog-card .v-input textarea,
html.dark .rt-add-task-dialog-card .v-select__selection,
html.dark .rt-add-task-dialog-card .v-label {
  color: rgba(255, 255, 255, 0.92) !important;
}
html.dark .rt-add-task-dialog-card .v-input textarea::placeholder {
  color: rgba(255, 255, 255, 0.45) !important;
}
html.dark .rt-add-task-dialog__actions .v-btn--text {
  color: #e1bee7 !important;
}
html.dark .rt-detail .v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)
  > .v-input__control
  > .v-input__slot
  fieldset {
  color: rgba(255, 255, 255, 0.28) !important;
}
html.dark .rt-detail .v-input textarea,
html.dark .rt-detail .v-label {
  color: rgba(255, 255, 255, 0.85);
}
html.dark .rt-detail .v-input textarea::placeholder {
  color: rgba(255, 255, 255, 0.45);
}
</style>
